<template>
  <v-card>
    <card-toolbar title="Excel İle Toplu Rehber Kaydı">
    </card-toolbar>
    <v-card-text>
      <v-alert
        prominent
        text
        type="info"
      >
        <v-row align="center">
          <v-col class="grow">
            Örnek excel dosya formatında hazırladığınız rehber kayıtlarını aktarın.
          </v-col>
        </v-row>
      </v-alert>

<!--      <router-link
        :to="{ name: 'group.contacts.index' }"
        class="text-decoration-none"
      >
        <v-alert dense outlined type="warning" prominent>
          Rehberde tekrar eden numaraları <b>Grupları Listele</b> sekmesinde
          <v-icon medium>repeat</v-icon> butonundan kontrol edebilirsiniz.
        </v-alert>
      </router-link>-->

      <v-form
        ref="form"
        lazy-validation
      >
        <v-layout
          row
          wrap
        >
          <v-container fluid>
            <v-flex xs12>
              <v-text-field
                label="Excel Dosyasını Seçiniz"
                @click='pickFile'
                readonly
                v-model='fileName'
                required
                prepend-inner-icon='attach_file'
                :rules="[
                  $rules.required({
                    falseValues: ['', null],
                    message: 'Bir dosya yüklemelisiniz',
                  }),
                ]"
              >
              </v-text-field>
              <input
                type="file"
                style="display: none"
                ref="file"
                required
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                @change="onFilePicked"
              >
            </v-flex>
            <v-flex xs12>
              <v-select
                v-model="group_id"
                :items="excelDefine"
                item-text="name"
                item-value="id"
                label="Yüklenecek Grup"
                required
                :rules="[
                  $rules.required({
                    falseValues: ['', null],
                    message: 'Grup seçimi yapmalısınız',
                  }),
                ]"
              >
              </v-select>
            </v-flex>
            <div class="text-xs-right mt-2">
              <v-layout row>
                <ExcelButton type="contact"></ExcelButton>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  @click="sendFile"
                >Yüklemeye Başla</v-btn>
              </v-layout>
            </div>
          </v-container>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import CardToolbar from '../CardToolbar.vue';
import ExcelButton from '../Sms/ExcelButton.vue';

export default {
  components: { CardToolbar, ExcelButton },
  props: ['groups'],
  data: () => ({
    excelDefine: [
      { id: 'excelDefine', name: 'Grubu Excelden Belirle' },
    ],
    file: {},
    fileName: '',
    group_id: 'all',
  }),
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    pickFile() {
      this.$refs.file.click();
    },
    onFilePicked(e) {
      const { files } = e.target;
      if (files[0] !== undefined) {
        this.fileName = files[0].name;
        if (this.fileName.lastIndexOf('.') <= 0) {
          return;
        }
        this.file = { files };
      }
    },
    sendFile() {
      if (this.$refs.form.validate()) {
        const url = 'add/contact/excel';
        const t = new FormData();

        t.append('excel', this.file.files[0]);
        t.append('group_id', this.group_id);
        this.send({
          route: url,
          data: t,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(() => this.$refs.form.reset());
      }
    },
  },
  watch: {
    groups(newlyGroups) {
      this.excelDefine.push(...newlyGroups);
    },
  },
};
</script>
